// extracted by mini-css-extract-plugin
module.exports = {"item":"styles-module_item_1yLOj","title":"styles-module_title_1zsPo","info":"styles-module_info_3yUtt","value":"styles-module_value_1-IYA"};